import { useState } from 'react';

/**
 * Open/close state for a variant selector's "Learn More" modal.
 *
 * Deprecated in favor of the `useModal` hook, but still used in some variant
 * selector blocks that haven't been refactored yet.
 */
export function useVariantSelectorModal() {
  const [modalOpen, setModalOpen] = useState(false);

  const showModal = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };

  const hideModal = (e) => {
    const togglerElement = e.target.closest('[modal-toggler="true"]');
    if (togglerElement) {
      e.preventDefault();
      setModalOpen(false);
    }
  };

  return { modalOpen, showModal, hideModal };
}
